import React from "react";
import { Box, Typography } from "@mui/material";
import { getStyles } from "./Statistics.styles";

const Statistics = () => {
  const styles = getStyles();

  return (
    <Box sx={styles.statisticsSection}>
      <Typography variant="h2" component="h2">
        Realitatea copiilor din România
      </Typography>

      <Box sx={styles.statisticsContent}>
        <Box sx={styles.statisticsItem}>
          <Typography variant="h3" component="h3" gutterBottom>
            Cititul nu e înțeles
          </Typography>
          <Typography variant="body1" component="p">
            Astăzi, 4 din 10 elevi din România se confruntă cu analfabetism
            funcțional - pot citi, dar nu înțeleg ce citesc.
          </Typography>
        </Box>
        <Box sx={styles.statisticsItem}>
          <Typography variant="h3" component="h3" gutterBottom>
            Acces la bibliotecă
          </Typography>
          <Typography variant="body1" component="p">
            6 din 10 școli nu au o bibliotecă. Accesul la cărți este unul dintre
            cei mai puternici factori predictivi pentru succesul copiilor.
          </Typography>
        </Box>
        <Box sx={styles.statisticsItem}>
          <Typography variant="h3" component="h3" gutterBottom>
            Puterea unei cărți
          </Typography>
          <Typography variant="body1" component="p">
            40% dintre cititori spun că lectura le-a oferit un sentiment real de
            conexiune cu oamenii din jur.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Statistics;
